webpackJsonp([8],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _constants = __webpack_require__(555);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _TemplateLandingPage = __webpack_require__(578);

var _TemplateLandingPage2 = _interopRequireDefault(_TemplateLandingPage);

var _TwoCols = __webpack_require__(571);

var _TwoCols2 = _interopRequireDefault(_TwoCols);

var _SliderTestimonialCardStars = __webpack_require__(586);

var _SliderTestimonialCardStars2 = _interopRequireDefault(_SliderTestimonialCardStars);

var _HeroPartners = __webpack_require__(906);

var _HeroPartners2 = _interopRequireDefault(_HeroPartners);

var _CenteredTitleSection = __webpack_require__(572);

var _CenteredTitleSection2 = _interopRequireDefault(_CenteredTitleSection);

__webpack_require__(908);

var _NewOurResultsv = __webpack_require__(597);

var _NewOurResultsv2 = _interopRequireDefault(_NewOurResultsv);

var _CardTrialv = __webpack_require__(566);

var _CardTrialv2 = _interopRequireDefault(_CardTrialv);

var _RequestContactv = __webpack_require__(909);

var _RequestContactv2 = _interopRequireDefault(_RequestContactv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import NewMenu from '../../blocks/Menu/NewMenu'


exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var headData = _ref.headData,
        company = _ref.company;
    return console.log(company), _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: 'https://mercos.com/integracao-erp' })
        ),
        _react2.default.createElement(MarketplacePartner, { company: company })
    );
});

var MarketplacePartner = function (_Component) {
    _inherits(MarketplacePartner, _Component);

    function MarketplacePartner(props) {
        _classCallCheck(this, MarketplacePartner);

        return _possibleConstructorReturn(this, (MarketplacePartner.__proto__ || Object.getPrototypeOf(MarketplacePartner)).call(this, props));
    }

    _createClass(MarketplacePartner, [{
        key: 'setPartnerIdCookie',
        value: function setPartnerIdCookie(partnerId) {
            _jsCookie2.default.set('leaderPartnerId', partnerId);
        }
    }, {
        key: 'render',
        value: function render() {
            var companyData = this.props.company.data,
                id = companyData.partner_id,
                title = companyData.title,
                logo = companyData.partner_logo,
                email = companyData.email || '',
                portifolioOwner = companyData.portifolio_owner;

            console.log(companyData);
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.setPartnerIdCookie(id),
                _react2.default.createElement(
                    _TemplateLandingPage2.default,
                    { representative: true, marketplace: true },
                    _react2.default.createElement(_HeroPartners2.default, { companyLogo: logo, stackedButtons: true, title: _react2.default.createElement(
                            _react.Fragment,
                            null,
                            'Automatize seu processo comercial e acelere suas vendas'
                        ), description: _react2.default.createElement(
                            _react.Fragment,
                            null,
                            'Use o for\xE7a de vendas e e-commerce B2B Mercos integrado ao ',
                            title,
                            ' e ganhe efici\xEAncia da entrada do pedido ao faturamento'
                        ),
                        cta: _react2.default.createElement(_RequestContactv2.default, {
                            className: 'btn-partner-contact',
                            portifolioOwner: portifolioOwner,
                            partnerEmail: email,
                            partnerId: id,
                            partnerName: title
                        })
                    }),
                    _react2.default.createElement(
                        'section',
                        { className: 'gray-bg' },
                        _react2.default.createElement(_CenteredTitleSection2.default, { title: _react2.default.createElement(
                                _react.Fragment,
                                null,
                                'A solu\xE7\xE3o mais pr\xE1tica e completa do mercado para seu time de vendas'
                            ) }),
                        _react2.default.createElement(_NewOurResultsv2.default, { hideErps: true })
                    ),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'vendasOrganizadas', reverse: true }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'semErrosParceiros' }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'aplicativoPotencializa', reverse: true }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'vendaOnlineParceiros' }),
                    _react2.default.createElement(
                        'section',
                        null,
                        _react2.default.createElement(_SliderTestimonialCardStars2.default, { descriptionH4: true, title: _constants.SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS + ' clientes melhoram a sua opera\xE7\xE3o comercial com a Mercos.', parceiros: true, overtitleUsers: true })
                    ),
                    _react2.default.createElement(_CardTrialv2.default, { horizontalCard: true, modalSmall: true, text: 'Agende uma r\xE1pida demonstra\xE7\xE3o do software Mercos para conhecer as funcionalidades e veja como \xE9 simples emitir e gerenciar pedidos, totalmente integrado ao seu ERP.',
                        ctaBtn: _react2.default.createElement(_RequestContactv2.default, {
                            className: 'btn-partner-contact',
                            portifolioOwner: portifolioOwner,
                            partnerEmail: email,
                            partnerId: id,
                            partnerName: title }) })
                )
            );
        }
    }]);

    return MarketplacePartner;
}(_react.Component);

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var wrapper = document.activeElement.closest('.activity-wrapper');
            var button = wrapper.querySelector('.activity-dropdown-button');
            var dropdown = wrapper.querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId,
                rdWhatsappLauncherReady: false
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                value = value.trim();
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};
            var fieldsToValidate = FIELDS;

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            fieldsToValidate.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            if (!email) return false;
            var trimmedEmail = email.trim();
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(trimmedEmail.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                data['cf_numero_de_vendedores'] = this.state.users;

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
            if (this.props.replaceTrialWithWhatsapp) {
                this.watchRDWhatsappLauncher();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopRDWhatsappPoll();
            if (this.rdWhatsappFallbackTimer) {
                clearTimeout(this.rdWhatsappFallbackTimer);
            }
        }
    }, {
        key: 'isRDWhatsappLauncherReady',
        value: function isRDWhatsappLauncherReady() {
            if (typeof document === 'undefined') return false;
            return Boolean(document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button'));
        }
    }, {
        key: 'stopRDWhatsappPoll',
        value: function stopRDWhatsappPoll() {
            if (this.rdWhatsappPollTimer) {
                clearInterval(this.rdWhatsappPollTimer);
                this.rdWhatsappPollTimer = null;
            }
        }
    }, {
        key: 'watchRDWhatsappLauncher',
        value: function watchRDWhatsappLauncher() {
            var _this4 = this;

            if (this.isRDWhatsappLauncherReady()) {
                this.setState({ rdWhatsappLauncherReady: true });
                return;
            }

            if (typeof document === 'undefined') return;

            this.rdWhatsappPollTimer = setInterval(function () {
                if (!_this4.isRDWhatsappLauncherReady()) return;
                _this4.setState({ rdWhatsappLauncherReady: true });
                _this4.stopRDWhatsappPoll();
            }, 300);

            this.rdWhatsappFallbackTimer = setTimeout(function () {
                _this4.stopRDWhatsappPoll();
            }, 7000);
        }
    }, {
        key: 'openRDWhatsappLauncher',
        value: function openRDWhatsappLauncher(e) {
            e.preventDefault();

            if (typeof window !== 'undefined' && typeof window.__mercosOpenRDWhatsappLauncher === 'function') {
                if (window.__mercosOpenRDWhatsappLauncher()) return;
            }

            var launcher = typeof document !== 'undefined' ? document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button') : null;

            if (launcher) {
                launcher.click();
                return;
            }

            (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            if (this.props.minimalStyle) {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal modal-context' },
                        this.getInlineForm()
                    )
                );
            } else if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: 'site-simple-modal-testimonials' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header-logo' },
                        _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        this.getForm()
                    ),
                    _react2.default.createElement(_ModalTestimonials2.default, null)
                );
            }
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this6 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this6.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this7.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this9 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this9.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getInlineForm',
        value: function getInlineForm() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this10.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.emailError, placeholder: this.props.formHeroStyle ? 'E-mail profissional' : 'Seu e-mail', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText || 'solicitar demonstração'
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        !this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'inline-trial-link modal-hide' },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    },
                                    title: 'Fa\xE7a um teste gr\xE1tis'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'ou-text' },
                                    'ou'
                                ),
                                ' fa\xE7a um teste gr\xE1tis \u203A'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'inline-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this11 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this11.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this12 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this12.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this13 = this;

            if (this.props.minimalStyle) {
                var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
                var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo mobile-only' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick(e) {
                                return _this13.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'peça uma demonstração'
                    ),
                    !this.props.hideTrialButton && _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick() {
                                return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                            },
                            href: '#',
                            title: 'Cadastre-se no Mercos!'
                        },
                        this.props.trialAndDemo || 'Faça um teste grátis'
                    ),
                    this.props.invertButtons && _react2.default.createElement(
                        'p',
                        { className: 'trial-info-text' },
                        'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                    )
                );
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    !this.props.hideTrialButton && this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'getNewFormButtons',
        value: function getNewFormButtons() {
            var _this14 = this;

            var _props = this.props,
                buttonVariant = _props.buttonVariant,
                textAlign = _props.textAlign,
                ctaButtonText = _props.ctaButtonText,
                demoButtonText = _props.demoButtonText,
                bottomText = _props.bottomText;


            var isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
            var isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

            // Determine outline color (white or green)
            var outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

            // Default: Faça=solid, Peça=outline
            // Inverted: Peça=solid, Faça=outline
            var trialButtonClass = isInverted ? 'new-form-btn ' + outlineClass : 'new-form-btn new-form-btn-solid-green';
            var demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : 'new-form-btn ' + outlineClass;

            var trialButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass,
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    title: 'Cadastre-se no Mercos!'
                },
                ctaButtonText || 'Faça um teste grátis'
            );

            var whatsappButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass + ' new-form-whatsapp-btn',
                    onClick: function onClick(e) {
                        return _this14.openRDWhatsappLauncher(e);
                    },
                    title: 'Fale conosco no WhatsApp'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'new-form-whatsapp-icon', 'aria-hidden': 'true' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '' })
                ),
                this.props.whatsappButtonText || 'Fale conosco no WhatsApp'
            );

            var demoButton = _react2.default.createElement(
                'button',
                {
                    className: demoButtonClass,
                    onClick: function onClick(e) {
                        return _this14.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                demoButtonText || 'Peça uma demonstração'
            );

            var primaryButton = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? whatsappButton : trialButton;
            var currentBottomText = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? this.props.whatsappBottomText : bottomText;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-buttons-wrapper text-align-' + textAlign },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form-buttons-container' },
                        isInverted ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            demoButton,
                            primaryButton
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            primaryButton,
                            demoButton
                        )
                    ),
                    currentBottomText && _react2.default.createElement(
                        'p',
                        { className: 'new-form-bottom-text' },
                        currentBottomText.includes('|') ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'desktop-text' },
                                currentBottomText
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-text' },
                                currentBottomText.split('|').map(function (part, index) {
                                    return _react2.default.createElement(
                                        _react.Fragment,
                                        { key: index },
                                        part.trim(),
                                        index < currentBottomText.split('|').length - 1 && _react2.default.createElement('br', null)
                                    );
                                })
                            )
                        ) : currentBottomText
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            // Only show buttons WITH form when minimalStyle + showForm + modalButtonText (final CTA case)
            // Otherwise follow normal logic (buttons only when !showForm)
            var shouldShowButtons = this.props.minimalStyle && this.props.showForm && this.props.modalButtonText ? true : !this.props.showForm;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.inline || this.props.minimalStyle ? 'new-form-wrapper-b2b' : '') + ' ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.newForm ? 'new-form-variant' : '') + ' ' + (this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    shouldShowButtons && this.props.newForm ? this.getNewFormButtons() : shouldShowButtons && this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this15.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : shouldShowButtons ? this.getTrialAndDemo() : null,
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.props.inline || this.props.minimalStyle ? this.getInlineForm() : this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    newForm: _propTypes2.default.bool,
    buttonVariant: _propTypes2.default.oneOf(['default', 'inverted', 'white', 'inverted-white']),
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    ctaButtonText: _propTypes2.default.string,
    demoButtonText: _propTypes2.default.string,
    bottomText: _propTypes2.default.string,
    minimalStyle: _propTypes2.default.bool,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    hideTitle: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool,
    replaceTrialWithWhatsapp: _propTypes2.default.bool,
    whatsappButtonText: _propTypes2.default.string,
    whatsappBottomText: _propTypes2.default.string
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false,
    inline: false,
    newForm: true,
    buttonVariant: 'default',
    textAlign: 'center',
    ctaButtonText: 'Faça um teste grátis',
    demoButtonText: 'Peça uma demonstração',
    bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    minimalStyle: false,
    showTrialLink: false,
    invertButtons: false,
    hideTitle: false,
    formHeroStyle: false,
    replaceTrialWithWhatsapp: false,
    whatsappButtonText: 'Fale conosco no WhatsApp',
    whatsappBottomText: ''
};
exports.default = DemoForm;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoFormB2B = function (_Component) {
    _inherits(DemoFormB2B, _Component);

    function DemoFormB2B(props) {
        _classCallCheck(this, DemoFormB2B);

        var _this = _possibleConstructorReturn(this, (DemoFormB2B.__proto__ || Object.getPrototypeOf(DemoFormB2B)).call(this, props));

        _this.handleActivityChange = function (activity) {
            _this.setState({ selectedActivity: activity });
        };

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopupB2B = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormB2B, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                partnerId: props.partnerId
            };
            var fields = props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(users) {
            this.setState({ 'users': users });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            var fields = this.props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this2.validateEmail(_this2.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'fale-consultor-b2b',
                    'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'ecommerce_b2b'
                };

                if (this.props.showUsersField) {
                    data['cf_numero_de_vendedores'] = this.state.users;
                }

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/';
                if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                    redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
                } else if (this.props.euCommerce) {
                    redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/';
                } else if (this.props.b2bPromo) {
                    redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b';
                }
                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this3 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this3.closeDemoModal();
                    }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    this.getForm()
                )
            );
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this4 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração',
                        ' ',
                        this.props.euCommerce ? this.props.euCommerce : '',
                        ' ',
                        this.props.b2bPromo ? this.props.b2bPromo : ''
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        this.props.formHeroStyle ? _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }) : _react2.default.createElement(_InputFloatingLabel2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        this.props.showUsersField && _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        (this.props.showForm || this.props.inline) && !this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-button-form' },
                    this.getModalButton(),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'integra\xE7\xE3o com mais de 200 ERPs ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'venda 24h por dia, 7 dias por semana ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this5 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'button',
                    {
                        href: '.',
                        className: 'new-button  ' + (this.props.trialAndDemo ? 'button-secondary' : 'button-primary'),
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || this.props.children || 'peça uma demonstração'
                ),
                this.props.buttonOnly && _react2.default.createElement(
                    'p',
                    { className: 'button-only-trial-info' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this6 = this;

            return _react2.default.createElement(
                'a',
                {
                    href: '.',
                    className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                    onClick: function onClick(e) {
                        return _this6.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || 'conheça o E-commerce B2B ›'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this7 = this;

            var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
            var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

            return _react2.default.createElement(
                'div',
                { className: 'wrapper-trial-and-demo mobile-only' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick(e) {
                            return _this7.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração'
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick() {
                            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                        },
                        href: '#',
                        title: 'Cadastre-se no Mercos!'
                    },
                    this.props.trialAndDemo
                ),
                this.props.invertButtons && _react2.default.createElement(
                    'p',
                    { className: 'trial-info-text' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper new-form-wrapper-b2b' },
                    this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA(),
                    this.props.showForm && _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.getForm()
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormB2B;
}(_react.Component);

DemoFormB2B.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    buttonOnly: _propTypes2.default.bool,
    modalButtonText: _propTypes2.default.string,
    hideTitle: _propTypes2.default.bool,
    submitButtonText: _propTypes2.default.string,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    showUsersField: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool
};
DemoFormB2B.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded',
    buttonOnly: false,
    hideTitle: false,
    submitButtonText: 'Solicitar demonstração',
    showTrialLink: false,
    invertButtons: false,
    showUsersField: true,
    formHeroStyle: false
};
exports.default = DemoFormB2B;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

var SITE_CONSTANTS = exports.SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9 mil',

  // Revenue (updated to 100 bi)
  ANNUAL_REVENUE: 'R$ 100 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 100 bi',

  // App ratings
  GOOGLE_PLAY_RATING: '4,9',
  GOOGLE_PLAY_REVIEWS: '7 mil avaliações',
  APP_STORE_RATING: '4,8',
  APP_STORE_REVIEWS: '2,8 mil avaliações',
  GOOGLE_BUSINESS_RATING: '4,6',
  GOOGLE_BUSINESS_REVIEWS: '701 avaliações',

  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  USERS_COUNT_DETAILED: '56.000',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'

  // Helper functions to get formatted numbers
};var getClientsCount = exports.getClientsCount = function getClientsCount() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS;
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED;
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA;
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT;
  }
};

var getRevenue = exports.getRevenue = function getRevenue() {
  var lowercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE;
};

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(556);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckList = function CheckList(_ref) {
    var className = _ref.className,
        title = _ref.title,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('check-list-container', className) },
        title && _react2.default.createElement(
            _Paragraph2.default,
            { className: 'check-list-title' },
            title
        ),
        _react2.default.createElement(
            'ul',
            { className: 'check-list' },
            children
        )
    );
};

CheckList.propTypes = {};

exports.default = CheckList;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(556);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckListItem = function CheckListItem(_ref) {
    var className = _ref.className,
        children = _ref.children;
    return _react2.default.createElement(
        'li',
        { className: (0, _classnames2.default)('check-list-item', className) },
        children
    );
};

CheckListItem.propTypes = {};

exports.default = CheckListItem;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(555);

var _DemoFormB2B = __webpack_require__(554);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

__webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardTrialNew = function CardTrialNew(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        contaAzul = _ref.contaAzul,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? '' : _ref$page,
        text = _ref.text,
        children = _ref.children,
        _ref$isEcommerce = _ref.isEcommerce,
        isEcommerce = _ref$isEcommerce === undefined ? false : _ref$isEcommerce,
        isReps = _ref.isReps,
        partnerId = _ref.partnerId,
        radius = _ref.radius,
        ctaText = _ref.ctaText,
        horizontalCard = _ref.horizontalCard,
        trialText = _ref.trialText,
        modalLink = _ref.modalLink,
        inlineBtns = _ref.inlineBtns,
        modalSmall = _ref.modalSmall,
        ctaBtn = _ref.ctaBtn;
    return _react2.default.createElement(
        'section',
        { className: 'trial-background new-box-trial-wrapper ' + (horizontalCard ? 'new-trial-horizontal' : '') + ' ' + (className ? className : '') },
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('box-trial', page) },
            _react2.default.createElement(
                'div',
                { className: 'container text-center' },
                isEcommerce ? _react2.default.createElement(
                    'h5',
                    { className: 'card-trial-title' },
                    text
                ) : _react2.default.createElement(
                    'h2',
                    { className: 'card-trial-title' },
                    text
                ),
                isEcommerce ? _react2.default.createElement(
                    _DemoFormB2B2.default,
                    null,
                    ctaText
                ) : ctaBtn ? ctaBtn : isReps ? _react2.default.createElement(_DemoForm2.default, { buttonVariant: 'white', textAlign: 'center' }) : _react2.default.createElement(_DemoForm2.default, { buttonVariant: 'white', textAlign: 'center' })
            )
        )
    );
};

CardTrialNew.propTypes = {
    children: _propTypes2.default.node,
    contaAzul: _propTypes2.default.bool,
    page: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    radius: _propTypes2.default.string
};

CardTrialNew.defaultProps = {
    contaAzul: false,
    partnerId: '',
    text: _react2.default.createElement(
        _react.Fragment,
        null,
        'Junte-se a mais de ',
        _constants.SITE_CONSTANTS.CLIENTS_COUNT,
        ' clientes',
        _react2.default.createElement('br', null),
        ' que est\xE3o potencializando vendas'
    )
};

exports.default = CardTrialNew;

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _CheckList = __webpack_require__(558);

var _CheckList2 = _interopRequireDefault(_CheckList);

var _CheckListItem = __webpack_require__(559);

var _CheckListItem2 = _interopRequireDefault(_CheckListItem);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SECTIONS = {
    vendasOrganizadas: {
        title: 'Vendas organizadas, ágeis e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mais tempo para o seu time'
            ),
            ': chega de ficar digitando pedidos no fim do dia'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    gestaoPedidos: {
        title: 'Gestão de pedidos organizada, ágil e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    representanteOrganizado: {
        title: 'Representante organizado, ágil e que não precisa ter retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mais tempo'
            ),
            ': sem necessidade de um profissional exclusivo para digita\xE7\xE3o de pedidos ou fazer o representante digitar pedidos no fim do dia'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    mobilidade: {
        title: 'Mobilidade para os representantes',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Funciona offline'
            ),
            ' e fecha vendas mesmo sem internet.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Funciona no tablet, celular e no notebook.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'O Aplicativo para representantes mais f\xE1cil de usar do mercado.'
        )],
        img: {
            url: '/images/site/landing-pages/mobilidade-representantes.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/mobilidade-representantes-mobile.png'
        }
    },
    entradaPedidos: {
        title: 'Entrada de pedidos organizada, ágil e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Pedidos num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            ),
            ': chega de redigitar pedidos no fim do dia.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/entrada-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    semErrosParceiros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Sem erros,',
            _react2.default.createElement('br', null),
            'mais resultados'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Integrado ao seu ERP o pedido \xE9 enviado direto ao faturamento'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os representantes apliquem descontos e pol\xEDticas comerciais corretamente'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure m\xFAltiplas tabelas de pre\xE7o por vendedor, cliente ou outro crit\xE9rio a sua escolha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Controle o estoque e mostre para os representantes a quantidade de itens dispon\xEDvel'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Calcule automaticamente vendas com impostos como ICMS, ST e IPI'
        )],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png'
        }
    },
    semErros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Sem erros,',
            _react2.default.createElement('br', null),
            'mais resultados'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Integrado ao seu ERP'
            ),
            ': al\xE9m de poder integrar com qualquer ERP, o Mercos conta com mais de 200 ERPs parceiros'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os representantes apliquem ',
            _react2.default.createElement(
                'b',
                null,
                'descontos e pol\xEDticas comerciais'
            ),
            ' corretamente'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure ',
            _react2.default.createElement(
                'b',
                null,
                'm\xFAltiplas tabelas de pre\xE7o por vendedor'
            ),
            ', cliente ou outro crit\xE9rio a sua escolha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Controle o estoque'
            ),
            ' e mostre para os representantes a quantidade de itens dispon\xEDvel'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Calcule automaticamente'
            ),
            ' pedidos com impostos como ICMS, ST e IPI'
        )],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png'
        }
    },
    imagemProfissional: {
        title: 'Imagem profissional no cliente',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Apresente um ',
            _react2.default.createElement(
                'b',
                null,
                'cat\xE1logo digital com fotos'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Atenda seus clientes de forma organizada desde a apresenta\xE7\xE3o at\xE9 o fechamento do pedido'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Tenha o ',
            _react2.default.createElement(
                'b',
                null,
                'hist\xF3rico de compra de cada cliente'
            ),
            ' e guie os pr\xF3ximos passos da negocia\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/imagem-profissional.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/imagem-profissional-mobile.png'
        }
    },
    potencialize: {
        title: 'Potencialize suas vendas',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'O aplicativo faz ',
            _react2.default.createElement(
                'b',
                null,
                'sugest\xF5es de venda'
            ),
            ' para o representante: produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumente em at\xE9 11%'
            ),
            ' a rentabilidade dos pedidos emitidos'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure a rentabilidade de cada produto e valorize os pedidos mais rent\xE1veis'
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    aplicativoPotencializa: {
        title: 'Aplicativo que potencializa o representante na hora da venda',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Venda em qualquer lugar mesmo sem internet'
            ),
            ': o sistema funciona offline'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Sugest\xF5es de venda para o representante'
            ),
            ': produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Hist\xF3rico completo do cliente'
            ),
            ', para n\xE3o esquecer de nenhuma oportunidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumento de 11% na rentabilidade das vendas'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Imagem profissional'
            ),
            ': cat\xE1logo digital com fotos de todos os produtos'
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    potencializaRepresentante: {
        title: 'Potencializa o representante na hora da venda',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Sugest\xF5es de venda'
            ),
            ': produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Hist\xF3rico completo do cliente'
            ),
            ': para n\xE3o esquecer de nenhuma oportunidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumento de 11% na rentabilidade das vendas'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Imagem profissional'
            ),
            ': cat\xE1logo digital com fotos de todos os produtos'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure a rentabilidade de cada produto e valorize os',
            _react2.default.createElement(
                'b',
                null,
                ' pedidos mais rent\xE1veis'
            )
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    vendaOnline: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Venda online para lojistas de todo o Brasil, 24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Loja virtual exclusiva'
            ),
            ' para vender para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja ',
            _react2.default.createElement(
                'b',
                null,
                'dispon\xEDvel para vendas a qualquer hora'
            ),
            ', quando o seu cliente quiser comprar'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do vendedor e do televendas: ofere\xE7a um vendedor online para os seus representantes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economize'
            ),
            ' em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    vendaOnlineParceiros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Venda online para lojistas de todo o Brasil, 24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'E-commerce B2B exclusivo para automatizar vendas de reposi\xE7\xE3o para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do representante e do televendas: ofere\xE7a um vendedor online para seu time comercial'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Economize em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja dispon\xEDvel para vendas a qualquer hora, quando o seu cliente quiser comprar'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    receba24h: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Receba pedidos online ',
            _react2.default.createElement('br', null),
            '24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Loja virtual exclusiva'
            ),
            ' para vender para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja ',
            _react2.default.createElement(
                'b',
                null,
                'dispon\xEDvel para vendas a qualquer hora'
            ),
            ', quando o seu cliente quiser comprar'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do vendedor e do televendas: ofere\xE7a um vendedor online para os seus representantes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economize'
            ),
            ' em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    gerencieVendedores: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Gerencie seus',
            _react2.default.createElement('br', null),
            ' vendedores'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Agenda para controle e organiza\xE7\xE3o de visitas'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Registro de atividades acess\xEDvel para gestor e vendedor'
            ),
            ': saiba exatamente o que aconteceu em cada visita'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os vendedores apliquem descontos e pol\xEDticas comerciais corretamente'
        )],
        img: {
            url: '/images/site/landing-pages/gerencie-vendedores.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/gerencie-vendedores-mobile.png'
        }
    },
    organizeUmSoLugar: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Organize tudo em um s\xF3 lugar'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine erros'
            ),
            ': emita pedidos de forma pr\xE1tica, respeitando as tabelas de pre\xE7os sem necessidade de redigita\xE7\xE3o.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Exporte pedidos em PDF'
            ),
            ': com apenas um clique envie pedidos por e-mail ou WhatsApp.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine as planilhas'
            ),
            ': organize pedidos, clientes e tabelas de pre\xE7os de todas as suas representadas em um \xFAnico sistema.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png'
        }
    },
    organizeUmSoLugarRep: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Organize tudo em um s\xF3 lugar'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine erros'
            ),
            ': emita pedidos de forma pr\xE1tica, respeitando as tabelas de pre\xE7os sem necessidade de redigita\xE7\xE3o.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie pedidos por Whatsapp'
            ),
            ': com apenas um clique exporte pedidos em pdf e envie por e-mail ou whatsapp.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine as planilhas'
            ),
            ': organize pedidos, clientes e tabelas de pre\xE7os de todas as suas representadas em um \xFAnico sistema.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png'
        }
    },
    definaMetas: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Defina metas, acompanhe seu desempenho e suas comiss\xF5es'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Acompanhe a evolu\xE7\xE3o das suas vendas'
            ),
            ': acesse relat\xF3rios em tempo real e controle os recebimentos por representada.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Gerencie sua equipe'
            ),
            ': acompanhe os resultados do seu time e defina estrat\xE9gias com base em dados.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png'
        }
    },
    definaMetasRep: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Defina metas, acompanhe seu desempenho e suas comiss\xF5es'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Acompanhe a evolu\xE7\xE3o das suas vendas'
            ),
            ': acesse relat\xF3rios em tempo real e controle os recebimentos por representada.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Gerencie sua equipe'
            ),
            ': acompanhe os resultados do seu time e defina estrat\xE9gias com base em dados.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png'
        }
    },
    monitoreClientes: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Monitore sua carteira de clientes'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Relat\xF3rios de Curva ABC'
            ),
            ': tenha clareza dos clientes que trazem o maior ou menor retorno e defina estrat\xE9gias personalizadas.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mapa de carteira por regi\xE3o'
            ),
            ': veja seu desempenho comercial em um mapa por estados e munic\xEDpios.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Esteja sempre \xE0 frente'
            ),
            ': obtenha insights valiosos sobre produtos e oportunidades de vendas.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/monitore.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/monitore.png'
        }
    }
};

var TwoCols = function (_Component) {
    _inherits(TwoCols, _Component);

    function TwoCols(props) {
        _classCallCheck(this, TwoCols);

        var _this = _possibleConstructorReturn(this, (TwoCols.__proto__ || Object.getPrototypeOf(TwoCols)).call(this, props));

        _this.reverse = _this.props.reverse;
        _this.sectionData = SECTIONS[_this.props.sectionName] || {};
        _this.demoCTA = _this.props.demoCTA;
        return _this;
    }

    _createClass(TwoCols, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'section',
                    { className: 'two-col ' + (this.reverse ? 'reverse' : '') },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'column' },
                            this.props.imgBeforeTitle && _react2.default.createElement(_Picture2.default, {
                                className: 'mobile-only',
                                src: this.sectionData.img.mobile,
                                alt: this.sectionData.title,
                                mobileSrc: this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''
                            }),
                            _react2.default.createElement(
                                'h3',
                                { className: 'title' },
                                this.props.title ? this.props.title : this.sectionData.title
                            ),
                            !this.props.imgBeforeTitle && _react2.default.createElement(_Picture2.default, {
                                className: 'mobile-only',
                                src: this.sectionData.img.mobile,
                                alt: this.sectionData.title,
                                mobileSrc: this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''
                            }),
                            _react2.default.createElement(
                                _CheckList2.default,
                                null,
                                this.sectionData.checklist.map(function (item, index) {
                                    return _react2.default.createElement(
                                        _CheckListItem2.default,
                                        { key: index },
                                        _react2.default.createElement(
                                            'h4',
                                            null,
                                            item
                                        )
                                    );
                                })
                            ),
                            this.demoCTA ? _react2.default.createElement(_DemoForm2.default, { modalLink: true, inlineBtns: true }) : ''
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'column' },
                            _react2.default.createElement(_Picture2.default, {
                                className: 'desktop-only',
                                src: this.sectionData.img.url,
                                alt: this.sectionData.title,
                                mobileSrc: ''
                            })
                        )
                    )
                )
            );
        }
    }]);

    return TwoCols;
}(_react.Component);

exports.default = TwoCols;


TwoCols.propTypes = {
    sectionName: _propTypes2.default.oneOf(Object.keys(SECTIONS)).isRequired
};

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CenteredTitleSection;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CenteredTitleSection(props) {
  return _react2.default.createElement(
    'section',
    { className: 'section-centered-title' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'h2',
        { className: 'title' },
        props.title
      )
    )
  );
}

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollDrag = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollDrag = exports.ScrollDrag = function (_React$Component) {
  _inherits(ScrollDrag, _React$Component);

  function ScrollDrag(props) {
    _classCallCheck(this, ScrollDrag);

    var _this = _possibleConstructorReturn(this, (ScrollDrag.__proto__ || Object.getPrototypeOf(ScrollDrag)).call(this, props));

    _this.p = 0;

    _this.onMouseDown = function (e) {
      e.persist();
      _this.isDown = true;

      _this.startX = e.pageX - _this.slider.current.offsetLeft;
      _this.scrollLeft = _this.slider.current.scrollLeft;
      _this.slider.current.style.cursor = "grabbing";
    };

    _this.onMouseLeave = function () {
      _this.isDown = false;
    };

    _this.onMouseUp = function () {
      _this.isDown = false;
      _this.slider.current.style.cursor = "pointer";
    };

    _this.onMouseMove = function (e) {
      if (!_this.isDown) {
        return;
      }
      e.preventDefault();
      var x = e.pageX - _this.slider.current.offsetLeft;
      var walk = (x - _this.startX) / 20;
      var z = _this.slider.current.scrollLeft - walk;

      _this.setState({ left: _this.state.left + z }, function () {
        _this.slider.current.scrollLeft = _this.state.left;
      });
    };

    _this.goLeftPercent = function () {
      return {
        transition: "0.01s"
      };
    };

    _this.goLeft = function () {
      if (_this.p < -970) {
        return;
      }
      _this.p += 0;
      _this.setState({ left: _this.p, percent: true });
    };

    _this.goRight = function () {
      if (_this.p === 0) {
        return;
      }
      _this.p += 0;
      _this.setState({ left: _this.p });
    };

    _this.mouseMove = function () {
      if (_this.state.left > 0) {
        _this.setState({ left: 0 });
        return;
      } else if (_this.state.left < -1) {
        _this.setState({ left: -0 });
        return;
      }
    };

    _this.state = {
      left: 0
    };

    _this.slider = _react2.default.createRef();
    return _this;
  }

  _createClass(ScrollDrag, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        {
          onMouseDown: this.onMouseDown,
          style: this.state.percent ? this.goLeftPercent() : this.mouseMove(),
          onMouseUp: this.onMouseUp,
          onMouseLeave: this.onMouseLeave,
          onMouseMove: this.onMouseMove,
          ref: this.slider,
          className: 'h-scroll-wrapper'
        },
        children
      );
    }
  }]);

  return ScrollDrag;
}(_react2.default.Component);

exports.default = ScrollDrag;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(555);

var _CardTrialv = __webpack_require__(566);

var _CardTrialv2 = _interopRequireDefault(_CardTrialv);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

__webpack_require__(568);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var b2b = _ref.b2b,
        card = _ref.card,
        children = _ref.children,
        hero = _ref.hero,
        headData = _ref.headData,
        distribuidor = _ref.distribuidor,
        footerCTAText = _ref.footerCTAText,
        representative = _ref.representative,
        marketplace = _ref.marketplace,
        industry = _ref.industry;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        headData && _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
            _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl }),
            headData.noFollow && _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'new-layout new-landing-page ' + (b2b ? 'new-landing-page-b2b' : '') + ' ' + (marketplace ? 'marketplace-partner' : '') },
            children
        ),
        representative ? '' : _react2.default.createElement(_CardTrialv2.default, { className: 'card-trial-landing-pages', trialText: 'comece gr\xE1tis', isEcommerce: true,
            text: b2b ? 'Todos os dias milhares de varejistas já compram online por catálogo B2B. Não fique para trás.' : distribuidor ? 'Comece a usar o sistema para distribuidoras que j\xE1 potencializou o processo comercial de mais de ' + _constants.SITE_CONSTANTS.CLIENTS_COUNT + ' empresas' : industry ? 'Comece a usar o sistema para ind\xFAstrias que j\xE1 potencializou o processo comercial de mais de ' + _constants.SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA + ' empresas' : footerCTAText ? footerCTAText : 'Junte-se a mais de 35 mil diretores comerciais, gerentes e representantes que est\xE3o potencializando e gerenciando suas vendas'
        }),
        _react2.default.createElement(_NewFooterV2.default, null)
    );
});

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _DragScroll = __webpack_require__(576);

var _DragScroll2 = _interopRequireDefault(_DragScroll);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SliderTestimonialCardStars = function (_Component) {
    _inherits(SliderTestimonialCardStars, _Component);

    function SliderTestimonialCardStars(props) {
        _classCallCheck(this, SliderTestimonialCardStars);

        var _this = _possibleConstructorReturn(this, (SliderTestimonialCardStars.__proto__ || Object.getPrototypeOf(SliderTestimonialCardStars)).call(this, props));

        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.sliderRef = _react2.default.createRef();
        return _this;
    }

    _createClass(SliderTestimonialCardStars, [{
        key: 'getTestimonials',
        value: function getTestimonials() {

            var testimonialList = {
                rafaelKrause: {
                    img: "rafael-krause",
                    imgAlt: "Rafael A. Krause, Grupo Herbia",
                    testimonial: "Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.",
                    author: "Rafael A. Krause",
                    company: "Grupo Herbia"
                },
                gustavoRibeiro: {
                    img: "gustavo-ribeiro",
                    imgAlt: "Gustavo Ribeiro, Impacttus Cosméticos",
                    testimonial: "Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.",
                    author: "Gustavo Ribeiro",
                    company: "Impacttus Cosméticos"
                },
                afonsoTonelli: {
                    img: "afonso-tonelli",
                    imgAlt: "Afonso Tonelli, Musical Plus",
                    testimonial: "Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.",
                    author: "Afonso Tonelli",
                    company: "Musical Plus"
                },
                felipeAlmeida: {
                    img: "felipe-almeida",
                    imgAlt: "Felipe Almeida, diretor da HPrime",
                    testimonial: "Hoje, os vendedores estão muito mais focados na relação com o cliente e em serem especialistas que ajudam na venda e no pós-venda do que em resolver as minúcias burocráticas de uma tabela, por exemplo",
                    author: "Felipe Almeida",
                    company: "HPrime"
                },
                joaoPauloOliveira: {
                    img: "joao-paulo-oliveira",
                    imgAlt: "João Paulo de Oliveira, proprietário Gao Cosméticos",
                    testimonial: "Eu pesquisei soluções de mercado e decidi contratar Mercos porque a ferramenta além de ser fácil de usar, me oferece três recursos que meu negócio precisa: e-commerce B2B, força de vendas e indicadores gerenciais",
                    author: "João Paulo de Oliveira",
                    company: "Gao Cosméticos"
                },
                alexandreSantos: {
                    img: "alexandre-santos-delicia-lanches",
                    imgAlt: "Alexandre Santos, sócio-proprietário da Delícia Lanches",
                    testimonial: "Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades",
                    author: "Alexandre Santos",
                    company: "Delícia Lanches"
                },
                ronaldoFabbro: {
                    img: "ronaldo-fabbro",
                    imgAlt: "Ronaldo dal Fabbro, Bake Shop",
                    testimonial: "Antes os pedidos eram feitos pelo WhatsApp. Agora nosso cliente compra de forma fácil, rápida e nós não precisamos realizar lançamentos manuais no sistema",
                    author: "Ronaldo dal Fabbro",
                    company: "Bake Shop"
                },
                francielMartins: {
                    img: "franciel",
                    imgAlt: "Franciel Martins, ZT Representações",
                    testimonial: "O Mercos pra gente foi um divisor de águas na questão da operação. Evoluímos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.",
                    author: "Franciel Martins",
                    company: "ZT Representações"
                },
                marceloSouza: {
                    img: "marcelo",
                    imgAlt: "Marcelo Souza, Diplomacia Representações",
                    testimonial: "Eu usava planilhas de Excel e fichas cadastrais para acessar o histórico do cliente. Hoje eu já não preciso mais perder esse tempo, tudo que eu cadastro no sistema de vendas já vai automaticamente para o e-commerce B2B.",
                    author: "Marcelo Souza",
                    company: "Diplomacia Representações"
                },
                felipeRodrigues: {
                    img: "felipe",
                    imgAlt: "Felipe Rodrigues, IF Consultoria e Representações",
                    testimonial: "Antes, para o varejista saber detalhes sobre um produto, precisava ligar pro representante, que ligava para a fábrica e retornava a ligação. Hoje, nem enviamos tabelas de preço, mais! Tudo está no Mercos e pode ser acessado e solicitado em segundo.",
                    author: "Felipe Rodrigues",
                    company: "IF Consultoria e Representações"
                },
                leandroCampos: {
                    img: "leandro-campos",
                    imgAlt: "Leandro Campos, Gestor Comercial e Marketing",
                    testimonial: "O E-commerce B2B é tão intuitivo e fácil de usar quanto o força de vendas. Mostramos aos vendedores como ele poderia ser um aliado valioso, especialmente quando não conseguissem atender o cliente em tempo real devido a estar na estrada ou em visitas.",
                    author: "Leandro Campos",
                    company: "Gestor Comercial e Marketing"
                },
                henriqueZompeiro: {
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'A integra\xE7\xE3o foi um grande diferencial'
                        ),
                        '. Estamos com nosso ERP h\xE1 mais de 15 anos, e ter um for\xE7a de vendas e e-commerce B2B com ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'uma integra\xE7\xE3o r\xE1pida e pr\xE1tica'
                        ),
                        ' s\xF3 melhorou nossa experi\xEAncia. Al\xE9m disso, n\xE3o afetou nosso fluxo operacional, o que fez com que os colaboradores n\xE3o tivessem resist\xEAncia na utiliza\xE7\xE3o do Mercos.'
                    ),
                    author: "Henrique Zompeiro",
                    company: "Corsa Bike Parts"
                },
                andersonMarques: {
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Nossos vendedores reduziram em 70% o tempo na emiss\xE3o dos pedidos'
                        ),
                        '. Agora tudo acontece em poucos cliques. Com o Mercos integrado ao ERP, tenho controle completo da minha opera\xE7\xE3o, da venda at\xE9 a gest\xE3o da produ\xE7\xE3o. ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Ganhei tempo no meu dia a dia para poder olhar para estrat\xE9gia'
                        ),
                        '.'
                    ),
                    author: "Anderson Marques",
                    company: "Keka Alimentos"
                },
                raimysonDias: {
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos facilitou muito para a gente a quest\xE3o das pol\xEDticas comerciais e hoje n\xE3o conseguimos mais viver sem. Trabalhamos estrat\xE9gias de promo\xE7\xF5es, a\xE7\xF5es e condi\xE7\xF5es, conseguimos separar por regi\xE3o, por representante e por cliente. ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'As tabelas personalizadas trouxeram uma vis\xE3o mais estrat\xE9gica e assertiva para nossa gest\xE3o de vendas'
                        ),
                        '.'
                    ),
                    author: "Raimyson Dias",
                    company: "Esquadromil"
                },
                ronaldoDalFabro: {
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'E-commerce B2B automatizou 100% o nosso processo de tirar pedidos'
                        ),
                        ', principalmente por ser integrado ao ERP. Antes, os pedidos eram feitos pelo WhatsApp. Agora, nosso cliente compra de forma f\xE1cil, r\xE1pida e n\xF3s n\xE3o precisamos realizar lan\xE7amentos manuais no sistema.'
                    ),
                    author: "Ronaldo Dal Fabbro",
                    company: "Bake Shop"
                }
            };

            var testimonialsIndustrias = [testimonialList.felipeAlmeida, testimonialList.alexandreSantos];

            var testimonialsRepresentantes = [testimonialList.francielMartins, testimonialList.marceloSouza, testimonialList.felipeRodrigues];

            var testimonialsB2BIndDist = [testimonialList.felipeAlmeida, testimonialList.leandroCampos, testimonialList.alexandreSantos];

            var testimonialsParceiros = [testimonialList.henriqueZompeiro, testimonialList.andersonMarques, testimonialList.raimysonDias, testimonialList.ronaldoDalFabro];

            var testimonialsHome = [testimonialList.rafaelKrause, testimonialList.gustavoRibeiro, testimonialList.afonsoTonelli, testimonialList.ronaldoFabbro, testimonialList.marceloSouza, testimonialList.felipeAlmeida];

            if (this.props.industrias) {
                return testimonialsIndustrias;
            }
            if (this.props.representantes) {
                return testimonialsRepresentantes;
            }
            if (this.props.newHome) {
                return testimonialsHome;
            }
            if (this.props.b2bIndDist) {
                return testimonialsB2BIndDist;
            }
            if (this.props.parceiros) {
                return testimonialsParceiros;
            }

            return testimonialsIndustrias;
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(direction) {
            var scrollAmount = 350;
            var sliderElement = this.sliderRef.current.slider.current;

            if (direction === 'left') {
                sliderElement.scroll({
                    left: sliderElement.scrollLeft - scrollAmount,
                    behavior: 'smooth'
                });
            } else if (direction === 'right') {
                sliderElement.scroll({
                    left: sliderElement.scrollLeft + scrollAmount,
                    behavior: 'smooth'
                });
            }

            var arrowsElement = sliderElement.parentNode.querySelector('.testimonial-arrows');
            var leftArrow = arrowsElement.querySelector('.testimonial-arrow-left');
            var rightArrow = arrowsElement.querySelector('.testimonial-arrow-right');
            setTimeout(function () {
                if (sliderElement.scrollLeft === 0) {
                    leftArrow.classList.add('slider-end');
                } else {
                    leftArrow.classList.remove('slider-end');
                }

                if (sliderElement.scrollLeft + sliderElement.clientWidth === sliderElement.scrollWidth) {
                    rightArrow.classList.add('slider-end');
                } else {
                    rightArrow.classList.remove('slider-end');
                }
            }, 350);
        }
    }, {
        key: 'defaultTestimonials',
        value: function defaultTestimonials() {
            var _this2 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-title ' + (this.props.title ? 'testimonials-title-picture-second-title' : '') },
                    _react2.default.createElement(_Picture2.default, { className: 'imagem-representantes', src: '/images/site/landing-pages/b2b-rep/reps.png' }),
                    this.props.overtitleUsers && _react2.default.createElement(
                        'div',
                        { className: 'label-small  desktop-only' },
                        '+35 MIL USU\xC1RIOS '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonials-title-slider-btns' },
                        this.props.title ? _react2.default.createElement(
                            'h2',
                            { className: 'font-36 font-bold' },
                            this.props.title
                        ) : this.props.industrias ? _react2.default.createElement(
                            'h2',
                            { className: 'font-36 font-bold' },
                            'Ind\xFAstrias est\xE3o conquistando mercados com a Mercos'
                        ) : _react2.default.createElement(
                            'h2',
                            { className: 'font-36 font-bold' },
                            'Quem j\xE1 evoluiu suas vendas com o ',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'nobr',
                                null,
                                'e-commerce'
                            ),
                            ' B2B da Mercos:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'testimonial-arrows' },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: 'testimonial-arrow testimonial-arrow-left slider-end',
                                    onClick: function onClick() {
                                        return _this2.handleScroll('left');
                                    }
                                },
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    alt: '',
                                    className: 'testimonial-arrow testimonial-arrow-right',
                                    onClick: function onClick() {
                                        return _this2.handleScroll('right');
                                    }
                                },
                                ' '
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _DragScroll2.default,
                    { ref: this.sliderRef },
                    this.getTestimonials().map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'testimonial-card' },
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-head' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'testimonial-card-stars' },
                                    '\u2605\u2605\u2605\u2605\u2605'
                                )
                            ),
                            _this2.props.descriptionH4 ? _react2.default.createElement(
                                'h4',
                                { className: 'testimonial-card-paragraph' },
                                testimonial.testimonial
                            ) : _react2.default.createElement(
                                'h5',
                                { className: 'testimonial-card-paragraph' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-header' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-card-author-company' },
                                    testimonial.img && _react2.default.createElement(_Picture2.default, { className: 'profile-image', alt: testimonial.imgAlt, width: '50', src: "/images/site/depoimentos/" + testimonial.img + ".jpg" }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'testimonial-author-wrapper' },
                                        _react2.default.createElement(
                                            'h',
                                            { className: 'testimonial-card-author' },
                                            testimonial.author
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-company' },
                                            testimonial.company
                                        )
                                    )
                                )
                            )
                        );
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()
            );
        }
    }]);

    return SliderTestimonialCardStars;
}(_react.Component);

exports.default = SliderTestimonialCardStars;

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(555);

__webpack_require__(585);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewOurResults = function NewOurResults(_ref) {
    var hideErps = _ref.hideErps,
        showPedidos = _ref.showPedidos;
    return _react2.default.createElement(
        'div',
        { className: 'about-achievements' },
        _react2.default.createElement(
            'div',
            { className: 'about-achievements-item' },
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-number' },
                _constants.SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS
            ),
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-text' },
                'clientes'
            )
        ),
        _react2.default.createElement('div', { className: 'about-achievements-divider' }),
        _react2.default.createElement(
            'div',
            { className: 'about-achievements-item' },
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-number' },
                '+52 mil'
            ),
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-text' },
                'usu\xE1rios'
            )
        ),
        !hideErps && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement('div', { className: 'about-achievements-divider' }),
            _react2.default.createElement(
                'div',
                { className: 'about-achievements-item' },
                _react2.default.createElement(
                    'h4',
                    { className: 'about-achievements-item-number' },
                    '+250'
                ),
                _react2.default.createElement(
                    'h4',
                    { className: 'about-achievements-item-text' },
                    'ERPs integrados'
                )
            )
        ),
        _react2.default.createElement('div', { className: 'about-achievements-divider' }),
        _react2.default.createElement(
            'div',
            { className: 'about-achievements-item' },
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-number' },
                _constants.SITE_CONSTANTS.ANNUAL_REVENUE
            ),
            _react2.default.createElement(
                'h4',
                { className: 'about-achievements-item-text' },
                'Anuais movimentados atrav\xE9s do Mercos'
            )
        ),
        showPedidos && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement('div', { className: 'about-achievements-divider' }),
            _react2.default.createElement(
                'div',
                { className: 'about-achievements-item' },
                _react2.default.createElement(
                    'h4',
                    { className: 'about-achievements-item-number' },
                    '+ 14 MI'
                ),
                _react2.default.createElement(
                    'h4',
                    { className: 'about-achievements-item-text' },
                    'de pedidos emitidos por ano'
                )
            )
        )
    );
};

exports.default = NewOurResults;

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HeroPartners;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _DemoFormPartners = __webpack_require__(907);

var _DemoFormPartners2 = _interopRequireDefault(_DemoFormPartners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeroPartners(props) {

    return _react2.default.createElement(
        'div',
        { className: 'new-main-banner-v2 new-hero new-hero-purple-bg hero-v2' },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'column' },
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-logos' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/logo_mercos_footer.png', alt: 'Logomarca Mercos', className: 'hero-logos' }),
                    _react2.default.createElement(_Picture2.default, { src: props.companyLogo, alt: '', className: 'hero-logos', noWebp: true })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'title-wrapper' },
                    props.overtitle ? _react2.default.createElement(
                        'div',
                        { className: 'label-small' },
                        props.overtitle
                    ) : "",
                    _react2.default.createElement(
                        'h1',
                        { className: 'title' },
                        props.title
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'main-subheading-container' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'description' },
                        props.description
                    )
                ),
                _react2.default.createElement(_Picture2.default, { noWebp: true,
                    className: 'hero-img-partner-mobile hide-desktop',
                    src: '/images/site/partners/hero-img-partners.png',
                    alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B'
                }),
                props.cta
            ),
            _react2.default.createElement('div', { className: 'column desktop-only' })
        ),
        _react2.default.createElement(_Picture2.default, { noWebp: true,
            className: 'hero-img-partner hide-mobile',
            src: '/images/site/partners/hero-img-partners.png',
            alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B'
        }),
        _react2.default.createElement('div', { className: 'full-width-white-fill' })
    );
}

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users', 'company', 'needs'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoFormPartners = function (_Component) {
    _inherits(DemoFormPartners, _Component);

    function DemoFormPartners(props) {
        _classCallCheck(this, DemoFormPartners);

        var _this = _possibleConstructorReturn(this, (DemoFormPartners.__proto__ || Object.getPrototypeOf(DemoFormPartners)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormPartners, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                needs: '',
                typingTimeout: 0,
                partnerId: props.partnerId
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    'cf_numero_de_vendedores': this.state.users,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';
                if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';else if (this.state.users === USERS.cinquenta || this.state.users === USERS.cinquentaum) redirectLink = 'https://materiais.mercos.com/tp-mid-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this4 = this;

            if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this4.closeDemoModal();
                    }, className: 'site-simple-modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header-logo' },
                    _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    this.getForm()
                ),
                _react2.default.createElement(_ModalTestimonials2.default, null)
            );
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this5 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this5.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this6 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this6.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this7 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this7.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'company', value: this.state.company, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.companyError, placeholder: 'Empresa' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement('textarea', { id: 'needs-field', defaultValue: this.state.needs, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, placeholder: 'Observa\xE7\xF5es' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this9 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: 'new-button button-secondary ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this9.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this10 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this10.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: 'new-button button-primary  button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    this.getTrialAndDemo(),
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { div: true, className: 'show-full-form' },
                        this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormPartners;
}(_react.Component);

DemoFormPartners.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool
};
DemoFormPartners.defaultProps = {
    b2b: false,
    contaAzul: false
};
exports.default = DemoFormPartners;

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _ButtonLink = __webpack_require__(557);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

__webpack_require__(672);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'phone', 'company', 'needs'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var RequestContactv3 = function (_Component) {
    _inherits(RequestContactv3, _Component);

    function RequestContactv3(props) {
        _classCallCheck(this, RequestContactv3);

        var _this = _possibleConstructorReturn(this, (RequestContactv3.__proto__ || Object.getPrototypeOf(RequestContactv3)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);
        return _this;
    }

    _createClass(RequestContactv3, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                showDemoForm: false,
                name: '',
                email: '',
                phone: '',
                erp: '',
                needs: '',
                users: '',
                activity: '',
                company: '',
                typingTimeout: 0
            };

            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });

            return initialObject;
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true,
                showDemoForm: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false,
                showDemoForm: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var stateKey = void 0;
            var targetId = e.target.id;
            var value = e.target.value;

            if (targetId.includes('-field')) {
                stateKey = targetId.substring(0, targetId.indexOf('-field'));
            } else if (targetId === 'email') {
                stateKey = 'email';
            } else if (targetId === 'telephone') {
                stateKey = 'phone';
            } else {
                stateKey = targetId;
            }

            if (stateKey === 'phone') {
                value = this.phoneMask(value);
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, stateKey, value), _defineProperty(_setState, stateKey + 'Error', false), _defineProperty(_setState, stateKey + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (stateKey === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexPhone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'phone':
                        {
                            newState[campo + 'Error'] = !regexPhone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'phoneMask',
        value: function phoneMask(value) {
            var cleanPhone = value ? value.replace(/\D/g, "") : '',
                numberLength = cleanPhone.length;

            if (numberLength > 10) {
                cleanPhone = cleanPhone.slice(0, 7) + '-' + cleanPhone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanPhone = cleanPhone.slice(0, 6) + '-' + cleanPhone.slice(6);
            }

            if (numberLength > 2) {
                cleanPhone = cleanPhone.slice(0, 2) + ') ' + cleanPhone.slice(2);
            }

            if (numberLength > 0) {
                cleanPhone = '(' + cleanPhone.slice(0);
            }

            return cleanPhone;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var _this4 = this;

            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'canais-lp',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    name: this.state.name,
                    email: this.state.email,
                    company_name: this.state.company,
                    personal_phone: this.state.phone,
                    'cf_atividade_da_empresa': this.state.activity,
                    'cf_numero_de_vendedores': this.state.users,
                    cf_observacoes: this.state.needs || '',
                    cf_carteira_clientes_canais: this.props.portifolioOwner || '',
                    'cf_codigo_do_parceiro_meus_pedidos': this.props.partnerId,
                    'cf_nome_do_parceiro_canais1': this.props.partnerName

                };

                this.rdGateway.sendToRDStation(data);

                this.setState({
                    showDemoForm: false
                });

                setTimeout(function () {
                    _this4.setState({
                        showDemoModal: false,
                        showDemoForm: true
                    });
                }, 3000);
            }
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this5.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('new-form-floating-inputs', this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form' },
                        _react2.default.createElement(
                            'p',
                            { className: 'new-form-title' },
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'new-form-subtitle' },
                            'Um de nossos consultores entrar\xE1 em contato.'
                        ),
                        _react2.default.createElement(
                            'form',
                            { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                    return _this5.submitForm(e);
                                } },
                            _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name-field', value: this.state.name, onChange: function onChange(e) {
                                    return _this5.handleChange(e);
                                }, error: this.state.nameError, autoFocus: true, placeholder: 'Nome' }),
                            _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                    return _this5.handleChange(e);
                                }, error: this.state.emailError, placeholder: 'E-mail' }),
                            _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.phone, onChange: function onChange(e) {
                                    return _this5.handleChange(e);
                                }, error: this.state.phoneError, maxLength: '15', placeholder: 'Telefone' }),
                            _react2.default.createElement(_InputFloatingLabel2.default, { id: 'company-field', value: this.state.company, onChange: function onChange(e) {
                                    return _this5.handleChange(e);
                                }, error: this.state.companyError, placeholder: 'Empresa' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-wrapper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                    '\xA0'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'activity-dropdown' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                                return _this5.handleActivityOptionClick(ACTIVITY.industria);
                                            } },
                                        _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                        'Ind\xFAstrias'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                                return _this5.handleActivityOptionClick(ACTIVITY.distribuicao);
                                            } },
                                        _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                        'Distribuidoras'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                                return _this5.handleActivityOptionClick(ACTIVITY.rep);
                                            } },
                                        _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                        'Representantes'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                                return _this5.handleActivityOptionClick(ACTIVITY.outra);
                                            } },
                                        _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                        'Outra'
                                    )
                                ),
                                this.state.activityError ? _react2.default.createElement(
                                    'div',
                                    { style: { color: 'red' } },
                                    'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                ) : null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'floating-label' },
                                    'Qual \xE9 a atividade da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'wrapper-input-vendedores' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'label' },
                                        'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'group-buttons' },
                                        _react2.default.createElement(
                                            _Button2.default,
                                            { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                    return _this5.handlerUsers(USERS.um);
                                                } },
                                            '1'
                                        ),
                                        _react2.default.createElement(
                                            _Button2.default,
                                            { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                    return _this5.handlerUsers(USERS.cinco);
                                                } },
                                            '2-5'
                                        ),
                                        _react2.default.createElement(
                                            _Button2.default,
                                            { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                    return _this5.handlerUsers(USERS.vinte);
                                                } },
                                            '6-20'
                                        ),
                                        _react2.default.createElement(
                                            _Button2.default,
                                            { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                    return _this5.handlerUsers(USERS.cinquenta);
                                                } },
                                            '21-50'
                                        ),
                                        _react2.default.createElement(
                                            _Button2.default,
                                            { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                    return _this5.handlerUsers(USERS.cinquentaum);
                                                } },
                                            '51 ou mais'
                                        ),
                                        this.state.usersError ? _react2.default.createElement(
                                            'div',
                                            { style: { color: 'red' } },
                                            'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                        ) : null
                                    )
                                )
                            ),
                            _react2.default.createElement('textarea', { id: 'needs-field', defaultValue: this.state.needs, onChange: function onChange(e) {
                                    return _this5.handleChange(e);
                                }, placeholder: 'Observa\xE7\xF5es' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'submit-demo-modal' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { type: 'submit', radius: this.props.radius, className: this.props.className },
                                    'SOLICITAR DEMONSTRA\xC7\xC3O'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-confirm', !this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(_Picture2.default, { className: 'success-icon', src: '/images/success.png', alt: 'Solicita\xE7\xE3o enviada com sucesso!' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'paragraph' },
                        'Sua solicita\xE7\xE3o foi enviada com sucesso!'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '.',
                            className: 'new-button button-primary button-cta',
                            onClick: function onClick(e) {
                                return _this6.openDemoModal(e);
                            }
                        },
                        this.props.children || 'peça uma demonstração'
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return RequestContactv3;
}(_react.Component);

RequestContactv3.propTypes = {
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    radius: _propTypes2.default.string
};
RequestContactv3.defaultProps = {
    radius: 'half-rounded'
};
exports.default = RequestContactv3;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/NewPartner/NewPartnerv2.jsx.530ff6b5.js